var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        visible: _vm.visible,
        size: "960px",
        title: _vm.$t("pc_biz_setCover" /** 设置封面 */),
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "yxt-form",
        { attrs: { "label-width": "120px" } },
        [
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_kng_kngcourse_lbl_currentcover" /** 当前封面 */
                ),
              },
            },
            [
              _c("img", {
                staticClass: "yxtbizf-br-4",
                attrs: { src: _vm.coverUrl, width: "242", height: "137" },
              }),
            ]
          ),
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t(
                  "pc_kng_kngcourse_lbl_coverorign" /** 封面来源设置 */
                ),
              },
            },
            [
              _c(
                "div",
                { staticClass: "yxtbiz-flex-center pv10" },
                [
                  _c(
                    "yxt-radio",
                    {
                      staticClass: "yxtbiz-mr12",
                      attrs: { label: 1 },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_kngcourse_lbl_usecover" /** 使用系统封面 */
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm.type === 1
                    ? [
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.change },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_kngcourse_btn_change" /** 换一换 */
                                )
                              )
                            ),
                          ]
                        ),
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.select },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_kngcourse_btn_choose" /** 选一张 */
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "yxtbiz-flex-center pv10" },
                [
                  _c(
                    "yxt-radio",
                    {
                      staticClass: "yxtbiz-mr12",
                      attrs: { label: 0 },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "pc_kng_kngcourse_btn_usecustomcovers" /** 使用自定义封面 */
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm.type === 0
                    ? [
                        _c(
                          "yxt-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.upload },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_kngcourse_btn_uploadcover" /** 上传封面 */
                                )
                              )
                            ),
                          ]
                        ),
                        _vm.info.fileType
                          ? _c(
                              "yxt-button",
                              {
                                attrs: { type: "text" },
                                on: { click: _vm.designer },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "pc_kng_kngcourse_btn_designcover" /** 设计封面 */
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "yxtbiz-flex-center pv10" },
                [
                  _c(
                    "yxt-radio",
                    {
                      attrs: { label: 3 },
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pc_kng_kngcourse_btn_kngcovers" /** 使用课件类型封面 */
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.showSmartCover
                ? _c(
                    "div",
                    { staticClass: "yxtbiz-flex-center pv10" },
                    [
                      _c(
                        "yxt-radio",
                        {
                          attrs: { label: 4 },
                          model: {
                            value: _vm.type,
                            callback: function ($$v) {
                              _vm.type = $$v
                            },
                            expression: "type",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "pc_kng_kngcourse_btn_capacitycovers" /** 使用智能封面 */
                                )
                              ) +
                              "\n          "
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "standard-size-12 color-gray-6 break-word",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "pc_kng_kngcourse_btn_capacitycovers1" /** （视频使用内容中的一帧、文档使用内容首页作为课程封面） */
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */)))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
          ),
        ],
        1
      ),
      _c("random-cover-drawer", { ref: "random" }),
      _c("yxtbiz-image-cropper", {
        attrs: {
          visible: _vm.showCoverUpload,
          "app-code": "kng",
          "module-name": "knowledgefiles",
          "function-name": "CoverUpload",
          source: "501",
          size: _vm.imgSize,
          suggest: { w: 640, h: 360 },
          filters: ".jpg,.png",
        },
        on: {
          "update:visible": function ($event) {
            _vm.showCoverUpload = $event
          },
          complete: _vm.complete,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }